import React, { useEffect, useState } from 'react';
import './CareerPage.css';

const Career = () => {
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch('https://zventures.in/api/get_jobs_automotive');
        const data = await response.json();

        if (data.success && Array.isArray(data.data)) {
          setJobs(data.data);
        } else {
          console.error('Invalid data structure:', data);
        }
      } catch (error) {
        console.error('Failed to fetch jobs:', error);
      }
    };

    fetchJobs();
  }, []);

  const openModal = (job) => setSelectedJob(job);
  const closeModal = () => setSelectedJob(null);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const decodeHTML = (html) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  };

  const renderHTML = (html) => {
    return { __html: decodeHTML(html).replace(/\n/g, '<br />') };
  };

  return (
    <div className="career-page">
      {/* Top Contact */}
      <div className="contact-section">
        <h1>Join Our Team</h1>
        <p className="description">Be a part of a dynamic and innovative team committed to driving the future of automotive automation.</p>
        <div className="hr-contact">
          <strong>Email:</strong>hhghr@zventures.in &nbsp; | &nbsp;
          <strong>Phone:</strong> +91 70699 90856
        </div>
      </div>

      {/* Job Cards */}
      <h2 className="section-heading">Current Openings</h2>
      <div className="job-cards">
        {jobs.length > 0 ? (
          jobs.map((job) => (
            <div key={job.id} className="job-card" onClick={() => openModal(job)}>
              <h3>{decodeHTML(job.job_title)}</h3>
              <p>{decodeHTML(job.location)}</p>
            </div>
          ))
        ) : (
          <p>Loading job opportunities...</p>
        )}
      </div>

      {/* Bottom Contact */}
      <div className="contact-section" style={{marginTop:'50px'}}>
        <h3>Still have questions?</h3>
        <p className="description">Feel free to contact our HR team for more information about career opportunities.</p>
        <div className="hr-contact">
          <strong>Email:</strong> hhghr@zventures.in &nbsp; | &nbsp;
          <strong>Phone:</strong> +91 70699 90856
        </div>
      </div>

      {/* Modal for Job Details */}
      {selectedJob && (
        <div className="job-modal" onClick={closeModal}>
          <div className="modal-content job-details-container" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={closeModal}>×</button>
            <h1>{decodeHTML(selectedJob.job_title)}</h1>

            <div className="job-meta" style={{ marginTop: '1rem' }}>
              <p><strong>Location:</strong> {decodeHTML(selectedJob.location)}</p>
              <p><strong>Job Type:</strong> {decodeHTML(selectedJob.job_type)}</p>
              <p><strong>Posted Date:</strong> {formatDate(selectedJob.posted_date)}</p>
            </div>

            <h2>Job Description</h2>
            <p dangerouslySetInnerHTML={renderHTML(selectedJob.description)} />

            <h2>Qualifications</h2>
            <p dangerouslySetInnerHTML={renderHTML(selectedJob.qualifications)} />

            <h2>Essential Duties</h2>
            <p dangerouslySetInnerHTML={renderHTML(selectedJob.essential_duties)} />

            {/* <div className="btn-group">
              <button className="btn-back" onClick={closeModal}>Back to Job Listings</button>
              <a href="jobs_apply.php" className="btn-back">Apply</a>
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default Career;
